// FIX-929 — intervention prise en charge par une entreprise (B2B) : facturée au
// partenaire, ou rattachée à une entreprise (décision du 15/10). Plus large que
// la garde de l'API (CourseController::store), qui ne refuse que la relance
// d'une intervention facturée au partenaire.
const isCompanyCourse = (course) =>
  !!course &&
  (String(course.paiement || '').toUpperCase() === 'B2B' ||
    Number(course.company_id) > 0);

export default isCompanyCourse;
